import React, { useState, useEffect } from 'react';
import { useReservations } from '../ReservationContext';

const ArrivalModal = ({ isOpen, reservation, onClose }) => {
  const { loading, updateReservationStatus, setSearchQuery, setSuccessMessage } = useReservations();
  const [partySize, setPartySize] = useState(2);

  useEffect(() => {
    if (reservation) {
      setPartySize(reservation.party_size);
    }
  }, [reservation]);

  const handleConfirmArrival = async (action) => {
    if (!reservation) return;

    const newStatus = action === 'seat' ? 'seated' : 'arrived';
    const success = await updateReservationStatus(reservation, newStatus, {
      actual_party_size: partySize,
    });

    if (success) {
      setSuccessMessage(action === 'seat' ? 'Guest seated!' : 'Guest marked as arrived');
      setSearchQuery('');
      onClose();
    }
  };

  if (!isOpen || !reservation) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content modal-arrival" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Guest Arrival</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <div className="arrival-content">
          <div className="arrival-guest-info">
            <h3>{reservation.customer_name}</h3>
            <p className="arrival-time">Reservation at {reservation.time}</p>
            {reservation.customer_phone && (
              <p className="arrival-phone">{reservation.customer_phone}</p>
            )}
            {reservation.special_requests && (
              <p className="arrival-notes">Notes: {reservation.special_requests}</p>
            )}
          </div>

          <div className="arrival-party-size">
            <label>Party Size</label>
            <div className="party-size-controls">
              <button
                className="party-btn"
                onClick={() => setPartySize(Math.max(1, partySize - 1))}
              >
                -
              </button>
              <span className="party-count">{partySize}</span>
              <button
                className="party-btn"
                onClick={() => setPartySize(partySize + 1)}
              >
                +
              </button>
            </div>
            {partySize !== reservation.party_size && (
              <span className="party-changed">
                (was {reservation.party_size})
              </span>
            )}
          </div>

          <div className="arrival-actions">
            <button
              className="btn btn-large btn-success"
              onClick={() => handleConfirmArrival('seat')}
              disabled={loading}
            >
              Seat Now
            </button>
            <button
              className="btn btn-large btn-secondary"
              onClick={() => handleConfirmArrival('arrived')}
              disabled={loading}
            >
              Mark Arrived
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArrivalModal;
